<template>
  <div>
    <FormWizardStepHeader
      title="About"
      optional
      description="Let startups know what makes a difference to you, what do you think is a good pitch, what your evaluation process is"
    />

    <FormItem
      invalid-message="The text must be at max 10000 characters long"
      :state="$v.about.$dirty ? !$v.about.$error : null"
    >
      <template slot="description">
        <FormInputLengthCounter
          label="Add a description up to 10000 characters."
          :max="10000"
          :text="form.about"
          strip-html
        />
      </template>

      <template>
        <FormRichTextEditor
          v-model="form.about"
          placeholder="Add your information here"
          @blur="$v.about.$touch()"
        />
      </template>
    </FormItem>
  </div>
</template>

<script>
import FormWizardStepHeader from '@/components/FormWizardStepHeader'
import FormItem from '@/components/form/FormItem'
import FormInputLengthCounter from '@/components/form/FormInputLengthCounter'
import FormRichTextEditor from '@/components/form/FormRichTextEditor/index'

export default {
  name: 'InvestorFormStepAbout',
  components: {
    FormRichTextEditor,
    FormWizardStepHeader,
    FormInputLengthCounter,
    FormItem
  },
  props: {
    $v: {
      type: Object,
      required: true
    },
    value: {
      type: Object
    }
  },
  data() {
    return {
      form: {
        ...this.value
      }
    }
  },
  watch: {
    value(newValue) {
      this.form = newValue
    },
    form: {
      deep: true,
      handler() {
        this.$emit('input', this.form)
      }
    }
  }
}
</script>
